<template>
  <section class="section">
    <div class="container container-small">
      <header>
        <transition name="text">
          <TextSection
            v-if="visible || mobile"
            :header="header"
            :description="description"
            :underline="true"
            :uppercase="false"
            :cutLength="310"
            :cutLengthTextBig ="210" />
        </transition>
      </header>
      <!-- <img class="image-overflow" :src="image" alt="Image" :class="{right: right}"> -->
    </div>
    <transition name="pulse">
      <SwipeHandler
        @swipeLeft="swipeLeft"
        @swipeRight="swipeRight"
        class="slider image-overflow"
       :class="{'image-overflow-visible' : visible}" >
        <div class="slide-wrapper">
          <figure class="slide" v-for="(item, index) in items" :key="'item' + index" :class="{
              'prev': index == (activeItem - 1 + items.length) % items.length,
              'active': index == activeItem,
              'next': index == (activeItem + 1) % items.length
            }">
            <img :src="item" :alt="museumData.title" />
          </figure>
        </div>
      </SwipeHandler>
    </transition>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import TextSection from '@/components/TextSection.vue'
import SwipeHandler from '@/components/SwipeHandler.vue'
import typewriter from '@/assets/images/mk/slider/typewriter.png'
import item2 from '@/assets/images/mk/slider/2.png'
import item3 from '@/assets/images/mk/slider/3.png'
import item4 from '@/assets/images/mk/slider/4.png'
import item5 from '@/assets/images/mk/slider/5.png'

export default {
  name: 'overflowSection',
  props: ['right', 'description', 'header', 'image', 'visible', 'mobile'],
  components: {
    TextSection,
    SwipeHandler
  },
  computed: {
    ...mapGetters([
      'museumData'
    ])
  },
  data: function () {
    return {
      activeItem: 0,
      loop: true,
      loopTimeout: null,
      items: [
        typewriter,
        item2,
        item3,
        item4,
        item5
      ]
    }
  },
  methods: {
    swipeRight () {
      this.showPrev()
    },
    swipeLeft () {
      this.showNext()
    },
    showNext () {
      this.activeItem = this.activeItem + 1 < this.items.length
        ? Math.min(this.activeItem + 1, this.items.length - 1)
        : 0
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    loopNext () {
      if (this.loop) {
        this.activeItem = this.activeItem + 1 < this.items.length
          ? Math.min(this.activeItem + 1, this.items.length - 1)
          : 0
        this.loopTimeout = window.setTimeout(() => {
          this.loopNext()
        }, 4000)
      }
    },
    showPrev () {
      this.activeItem = this.activeItem - 1 >= 0
        ? Math.max(this.activeItem - 1, 0)
        : this.items.length - 1
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    }
  },
  mounted () {
    setTimeout(this.loopNext, 4000)
  }
}
</script>

<style scoped lang="scss">
  header {
    width: 300px;
    max-width: 90vw;
    @include tablet {
      width: 100%;
      max-width: 100%;
      /deep/ {
        h2 {
          max-width: 100%;
        }
        .parts-wrapper {
          width: 100%;
        }
      }
    }
    @include mobile {
      /deep/ .multi {
        .parts-wrapper {
          max-height: 300px;
          min-height: 300px;
          margin-bottom: 0 !important;
          height: calc(650px - 100vw);
        }
      }
    }
    @include mobile-small {
      /deep/ .multi {
        .parts-wrapper {
          max-height: 310px;
          min-height: 310px;
          margin-bottom: 0;
        }
      }
    }
  }
  .section {
    position: relative;
    z-index: 2;
    .container {
      min-height: 604px;
      padding: 45px 0;
      @include tablet {
        min-height: 304px;
        padding: 45px 0 0;
      }
    }
  }
  .image-overflow {
    position: absolute;
    bottom: -20px;
    margin-top: -20px;
    right: 0;
    height: 100%;
    pointer-events: none;
    visibility: hidden;
    width: 50vw;

    @include desktop-small {
      right: 0;
    }
    @include tablet {
      position: relative;
      bottom: -30px;
      max-width: 100%;
      height: 600px;
      width: 100%;
    }
    @include mobile {
      height: 90vw;
    }

    &-visible {
      visibility: visible;
    } // END .image-overflow-visible;
  }
  .slide {
    display: none;
    transition: $transitionSlider;
    position: absolute;

    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    text-align: left;
    height: 100%;
    align-items: flex-end;
    padding: 0;
    margin: 0;
    img {
      max-width: 90%;
      max-height: 90%;
      height: auto;
      // width: 600px;
      @include tablet {
        max-height: 100%;
      }
    }
    p {
      margin: 0;
      font-weight: 500;
    }
    &.prev {
      display: flex;
      transform: translateX(-100vw);
      opacity: 0;
    }
    &.next {
      display: flex;
      transform: translateX(100vw);
      opacity: 0;
    }
    &.active {
      display: flex;
      transform: translateX(0);
      opacity: 1;
    }
    @include tablet {
      justify-content: center;
    }
  }
  .slide-wrapper {
    position: relative;
    min-width: 356px;
    width: 100%;
    overflow: hidden;
    height: 100%;
    text-align: left;
    margin-right: 80px;
    // @include desktop {
    //   .font-size-l & {
    //     height: 220px;
    //   }
    // }
    @include tablet {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      margin-right: 0;
    }
  }
</style>
